import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class ContactConfiguratorSellerRequest extends ValueObject {
  #userId
  #dealerId
  #vehicleId
  #color

  constructor({userId, dealerId, vehicleId, color}) {
    super()
    this.#userId = userId
    this.#dealerId = dealerId
    this.#vehicleId = vehicleId
    this.#color = color
  }

  static validate({userId, dealerId, vehicleId}) {
    if (!userId)
      throw InvalidParamsSharedError.create('[ContactConfiguratorSellerRequest.validate] param userId is required')
    if (!dealerId)
      throw InvalidParamsSharedError.create('[ContactConfiguratorSellerRequest.validate] param dealerId is required')
    if (!vehicleId)
      throw InvalidParamsSharedError.create('[ContactConfiguratorSellerRequest.validate] param vehicleId is required')
  }

  static create({userId, dealerId, vehicleId, color}) {
    ContactConfiguratorSellerRequest.validate({userId, dealerId, vehicleId})
    return new ContactConfiguratorSellerRequest({userId, dealerId, vehicleId, color})
  }

  get userId() {
    return this.#userId
  }

  get dealerId() {
    return this.#dealerId
  }

  get vehicleId() {
    return this.#vehicleId
  }

  get color() {
    return this.#color
  }

  get value() {
    return {
      userId: this.#userId,
      dealerId: this.#dealerId,
      vehicleId: this.#vehicleId,
      color: this.#color
    }
  }

  getBody() {
    return {
      dealerId: this.#dealerId,
      subjectData: {
        specsId: this.#vehicleId,
        color: this.#color
      }
    }
  }
}
